import React from 'react';
import AlphabetCell from '../AlphabetCell';

const VigenereTable = ({ table, selectedRow, selectedColumn }) => {
    // Function to generate Vigenere cipher table
    const firstRow = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

    return (
        <div style={{ maxWidth: "850px"}}>
            <div style={{ textAlign: 'left', margin: 0 }}>
                <AlphabetCell key={Math.random()} text={"-"} keepSmall={true} defaultColor={"green"} />
                <div key={Math.random()} style={{ display: 'inline-block', margin: 0 }}>
                    {firstRow.map((letter, colIndex) => (
                        <AlphabetCell key={colIndex} text={letter} keepSmall={true} isLast={colIndex !== 0 && colIndex % 25 === 0} defaultColor={"green"} textColor={"white"} />
                    ))}
                </div>
            </div>
            <div style={{ textAlign: 'left', margin: 0 }}>
                {table.map((row, rowIndex) => (

                    <div key={rowIndex} style={{ display: 'inline-block', margin: 0 }}>
                        <AlphabetCell key={Math.random()} text={row[0]} keepSmall={true} defaultColor={"green"} textColor={"white"} />
                        {row.map((letter, colIndex) => (
                            <AlphabetCell key={colIndex} text={letter} keepSmall={true} isLast={colIndex !== 0 && colIndex % 25 === 0} defaultColor={colIndex === selectedColumn || rowIndex === selectedRow ? "yellow" : "white"} isCipher={colIndex === selectedColumn && rowIndex === selectedRow} />
                        ))}
                        <br />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default VigenereTable;
